<template>
  <validation-provider
    #default="{ errors }"
    name="outdatedContract"
    :rules="{
      required: requiredField,
    }"
  >
    <b-form-group
      label="Contrato Defasado?"
      label-for="outdatedContract"
    >
      <v-select
        id="outdatedContract"
        v-model="outdatedContract"
        :class="errors.length > 0 ? 'error-select' : ''"
        :options="outdatedContractOptions"
        :placeholder="'Contrato Defasado?'"
        :disabled="readonly"
        :clearable="!readonly"
      >
        <template #option="{ label }">
          {{ label }}
        </template>
      </v-select>
      <small class="text-danger">{{ errors[0] }}</small>
    </b-form-group>
  </validation-provider>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'

export default {
  components: {
    BFormGroup,
    ValidationProvider,
    vSelect,
  },
  model: {
    prop: 'outdatedContractValue',
    event: 'outdatedContractChange',
  },
  props: {
    outdatedContractValue: {
      type: [Object, Boolean],
      required: false,
      default: null,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    requiredField: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      outdatedContractOptions: [
        { label: 'SIM', value: true },
        { label: 'NÃO', value: false },
      ],
    }
  },
  computed: {
    outdatedContract: {
      get() {
        return this.outdatedContractValue
      },
      set(value) {
        const valueMap = {
          true: { label: 'SIM', value: true },
          false: { label: 'NÃO', value: false },
        }

        this.$emit('outdatedContractChange', valueMap[value] || value)
      },
    },
  },
  watch: {
    outdatedContractValue(newVal) {
      this.outdatedContract = newVal
    },
  },
}
</script>

<style lang="scss">

.v-select {
  background-color: white;
}
</style>
